import React, { useState } from "react"
import * as Icons from "@nova/component-icons"
import { useTranslation } from "@nova/use-translation"
import { ID } from "@nova/constants"
import { useAppSelector } from "integrations/redux/hooks"
import { selectActiveWorkspace } from "features/data-management/workspace/WorkspaceManagementSlice"
import { selectFireById } from "features/entity-caching/fires/selectors"
import { findTagTreePath } from "@nova/util-tag-tree"

type CopyInviteLinkButtonProps = {
    entityId: ID
}
export const CopyInviteLinkButton = ({ entityId }: CopyInviteLinkButtonProps) => {
    const { t } = useTranslation()
    const [copied, setCopied] = useState(false)

    const activeProject = useAppSelector(selectFireById(entityId))
    const activeWorkspace = useAppSelector(selectActiveWorkspace())

    const buildUrl = () => {
        const base = window.location.origin
        if (!!activeProject) return base + `/workspace/${activeWorkspace?.id}/project/${entityId}`
        if (entityId === activeWorkspace?.id) return base + `/workspace/${entityId}`
        if (activeWorkspace) {
            const path = findTagTreePath(activeWorkspace.tagTree || {}, entityId, [])
            if (path) return base + `/workspace/${activeWorkspace.id}/explore/${path?.join("/")}`
        }
        return base
    }

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(buildUrl())
            setCopied(true)
            setTimeout(() => setCopied(false), 2000)
        } catch (err) {
            console.error("Failed to copy the URL:", err)
        }
    }

    return (
        <div className="flex items-center gap-2 cursor-pointer px-3 py-1.5" onClick={handleCopyUrl}>
            {copied ? (
                <>
                    <Icons.SmallIcon Icon={Icons.Checkmark} className="text-green-500" />
                    <div className="text-gray-0">{t("Link Copied")}</div>
                </>
            ) : (
                <>
                    <Icons.SmallIcon className="text-gray-100" Icon={Icons.Copy} />
                    <div className="text-gray-100">{t("Copy Link")}</div>
                </>
            )}
        </div>
    )
}
